import { render, staticRenderFns } from "./arviointipyynto-card.vue?vue&type=template&id=64278c07&scoped=true&"
import script from "./arviointipyynto-card.vue?vue&type=script&lang=ts&"
export * from "./arviointipyynto-card.vue?vue&type=script&lang=ts&"
import style0 from "./arviointipyynto-card.vue?vue&type=style&index=0&id=64278c07&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64278c07",
  null
  
)

export default component.exports